import { Analytics, getAnalytics, logEvent } from 'firebase/analytics';
import { getFirebaseApp } from './config';

let analytics: Analytics | null = null;

function getAnalyticsInstance(): Analytics | null {
  if (analytics) {
    return analytics;
  }

  try {
    analytics = getAnalytics(getFirebaseApp());
    return analytics;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[FIREBASE] Erro ao inicializar analytics: ', error);
    }
    return null;
  }
}

export const sendEvent = (tag: string): void => {
  const instance = getAnalyticsInstance();

  if (!instance) {
    return;
  }

  try {
    logEvent(instance, tag);
    if (process.env.NODE_ENV === 'development') {
      console.info('[FIREBASE] Evento logado: ', tag);
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[FIREBASE] Erro ao enviar evento: ', error);
    }
  }
};
